// extracted by mini-css-extract-plugin
export default {"main":"CollapseListPanel--main--q5fPj","collapse":"CollapseListPanel--collapse--91QO7","footerContent":"CollapseListPanel--footerContent--M+aLB"};